import React, { Component } from "react";
import { List } from 'antd'
import styles from "./index.module.less";
import classnames from 'classnames';

class ListTable extends Component {

    render() {
        const { columns, listData } = this.props;
        return (
            <div className={styles.main}>
                <div className={styles.header}>
                    <div className={classnames(styles.tableHeader, styles.table)} style={{ border: 0 }}>
                        {columns.map((item, index) => {
                            let style = {};
                            if (item.width)
                                style.width = item.width;
                            else {
                                style.width = "1px";
                                style.flexGrow = 1;
                            }
                            return (
                                <div key={index} className={classnames(styles.headerItem)} style={style}>
                                    {item.title}
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className={styles.body}>
                    <List
                        itemLayout="horizontal"
                        dataSource={listData}
                        renderItem={(dataItem, index) => {
                            return (
                                <div className={styles.table}>
                                    {columns.map(item => {
                                        let style = {};
                                        if (item.width)
                                            style.width = item.width;
                                        else {
                                            style.width = "1px";
                                            style.flexGrow = 1;
                                        }
                                        return (
                                            <div className={classnames(styles.headerItem)} style={style}>
                                                {item.render ? item.render(dataItem[item.key], dataItem, index) : dataItem[item.key]}
                                            </div>
                                        )
                                    })}
                                </div>
                            )
                        }}
                    >
                    </List>
                </div>
            </div>
        );
    }
}
export default ListTable